import i18n from "i18next";
import { FALLBACK_LOCALE, LOCAL_STORAGE_KEY, SupportedLocale, isSupportedLocale } from "./config";

export const detectFromNavigator = (lang: string | undefined | null): SupportedLocale => {
  if (typeof lang !== "string") return FALLBACK_LOCALE;

  // Match the primary subtag against the supported set (e.g. "fr-FR" -> "fr", "pt-BR" -> "pt").
  // Region/script subtags are ignored — catalogs are language-level (no pt-PT vs pt-BR split today).
  const base = lang.toLowerCase().split("-")[0];

  return isSupportedLocale(base) ? base : FALLBACK_LOCALE;
};

export const detectInitialLocale = (): SupportedLocale => {
  try {
    const stored = window.localStorage.getItem(LOCAL_STORAGE_KEY);
    if (isSupportedLocale(stored)) return stored;
  } catch {
    // localStorage may be unavailable (SSR, Safari private mode); fall through
  }

  if (typeof navigator !== "undefined") return detectFromNavigator(navigator.language);

  return FALLBACK_LOCALE;
};

export const persistLocale = (locale: SupportedLocale): void => {
  try {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, locale);
  } catch {
    // best-effort; same fallthrough as above
  }
};

// Apply BE-persisted user_info.language on auth boot. localStorage wins per the
// resolution chain (it reflects an explicit toggle in this browser), so we only
// hydrate from BE when LS has no preference yet. Once changeLanguage fires, the
// i18n languageChanged listener mirrors the new value to LS for future boots.
export const applyUserPreferredLocale = (beLanguage: unknown): void => {
  if (!isSupportedLocale(beLanguage)) return;

  try {
    const lsValue = window.localStorage.getItem(LOCAL_STORAGE_KEY);
    if (isSupportedLocale(lsValue)) return;
  } catch {
    // best-effort; fall through and apply BE
  }

  if (i18n.language !== beLanguage) i18n.changeLanguage(beLanguage);
};
